import { useInputValidation } from './useInputValidation';

const re =
  // eslint-disable-next-line regexp/no-unused-capturing-group
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;
// taken from chromium

export const useEmailValidation = (email?: string) => {
  return useInputValidation(email, [
    {
      validation: (v) => v !== undefined && re.test(String(v).toLowerCase()),
      message: 'Netfang er ekki á réttu formi.',
    },
  ]);
};
